/* tslint:disable */
/* eslint-disable */
/**
 * MAPIIO API
 * API mapové aplikace Mapiio pro klientskou JavaScriptovou / React část.
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { ExternalLinkConfVO } from '../model';
// @ts-ignore
import * as Objs from './index'
// @ts-ignore
import { DataResponseVO, DataRequestVO, ExportRequestVO } from '@mc/data-filter-react';

/**
 * ExternalLinksConfigControllerApi - axios parameter creator
 * @export
 */
export const ExternalLinksConfigControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ExternalLinkConfVO} externalLinkConfVO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createExternalLink: async (externalLinkConfVO: ExternalLinkConfVO, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'externalLinkConfVO' is not null or undefined
            assertParamExists('createExternalLink', 'externalLinkConfVO', externalLinkConfVO)
            const localVarPath = `/api/mapio/conf/externalLinks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(externalLinkConfVO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} externalLinkId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteExternalLink: async (externalLinkId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'externalLinkId' is not null or undefined
            assertParamExists('deleteExternalLink', 'externalLinkId', externalLinkId)
            const localVarPath = `/api/mapio/conf/externalLinks/{externalLinkId}`
                .replace(`{${"externalLinkId"}}`, encodeURIComponent(String(externalLinkId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllExternalLinks: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/mapio/conf/externalLinks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} externalLinkId 
         * @param {ExternalLinkConfVO} externalLinkConfVO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateExternalLink: async (externalLinkId: string, externalLinkConfVO: ExternalLinkConfVO, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'externalLinkId' is not null or undefined
            assertParamExists('updateExternalLink', 'externalLinkId', externalLinkId)
            // verify required parameter 'externalLinkConfVO' is not null or undefined
            assertParamExists('updateExternalLink', 'externalLinkConfVO', externalLinkConfVO)
            const localVarPath = `/api/mapio/conf/externalLinks/{externalLinkId}`
                .replace(`{${"externalLinkId"}}`, encodeURIComponent(String(externalLinkId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(externalLinkConfVO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ExternalLinksConfigControllerApi - functional programming interface
 * @export
 */
export const ExternalLinksConfigControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ExternalLinksConfigControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ExternalLinkConfVO} externalLinkConfVO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createExternalLink(externalLinkConfVO: ExternalLinkConfVO, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExternalLinkConfVO>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.createExternalLink(externalLinkConfVO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} externalLinkId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteExternalLink(externalLinkId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteExternalLink(externalLinkId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAllExternalLinks(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ExternalLinkConfVO>>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.findAllExternalLinks(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} externalLinkId 
         * @param {ExternalLinkConfVO} externalLinkConfVO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateExternalLink(externalLinkId: string, externalLinkConfVO: ExternalLinkConfVO, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExternalLinkConfVO>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.updateExternalLink(externalLinkId, externalLinkConfVO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ExternalLinksConfigControllerApi - factory interface
 * @export
 */
export const ExternalLinksConfigControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ExternalLinksConfigControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {ExternalLinkConfVO} externalLinkConfVO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createExternalLink(externalLinkConfVO: ExternalLinkConfVO, options?: any): AxiosPromise<ExternalLinkConfVO> {
            return localVarFp.createExternalLink(externalLinkConfVO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} externalLinkId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteExternalLink(externalLinkId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteExternalLink(externalLinkId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllExternalLinks(options?: any): AxiosPromise<Array<ExternalLinkConfVO>> {
            return localVarFp.findAllExternalLinks(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} externalLinkId 
         * @param {ExternalLinkConfVO} externalLinkConfVO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateExternalLink(externalLinkId: string, externalLinkConfVO: ExternalLinkConfVO, options?: any): AxiosPromise<ExternalLinkConfVO> {
            return localVarFp.updateExternalLink(externalLinkId, externalLinkConfVO, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ExternalLinksConfigControllerApi - interface
 * @export
 * @interface ExternalLinksConfigControllerApi
 */
export interface ExternalLinksConfigControllerApiInterface {
    /**
     * 
     * @param {ExternalLinkConfVO} externalLinkConfVO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExternalLinksConfigControllerApiInterface
     */
    createExternalLink(externalLinkConfVO: ExternalLinkConfVO, options?: any): AxiosPromise<ExternalLinkConfVO>;

    /**
     * 
     * @param {string} externalLinkId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExternalLinksConfigControllerApiInterface
     */
    deleteExternalLink(externalLinkId: string, options?: any): AxiosPromise<void>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExternalLinksConfigControllerApiInterface
     */
    findAllExternalLinks(options?: any): AxiosPromise<Array<ExternalLinkConfVO>>;

    /**
     * 
     * @param {string} externalLinkId 
     * @param {ExternalLinkConfVO} externalLinkConfVO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExternalLinksConfigControllerApiInterface
     */
    updateExternalLink(externalLinkId: string, externalLinkConfVO: ExternalLinkConfVO, options?: any): AxiosPromise<ExternalLinkConfVO>;

}

/**
 * ExternalLinksConfigControllerApi - object-oriented interface
 * @export
 * @class ExternalLinksConfigControllerApi
 * @extends {BaseAPI}
 */
export class ExternalLinksConfigControllerApi extends BaseAPI implements ExternalLinksConfigControllerApiInterface {
    /**
     * 
     * @param {ExternalLinkConfVO} externalLinkConfVO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExternalLinksConfigControllerApi
     */
    public createExternalLink(externalLinkConfVO: ExternalLinkConfVO, options?: any) {
        return ExternalLinksConfigControllerApiFp(this.configuration).createExternalLink(externalLinkConfVO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} externalLinkId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExternalLinksConfigControllerApi
     */
    public deleteExternalLink(externalLinkId: string, options?: any) {
        return ExternalLinksConfigControllerApiFp(this.configuration).deleteExternalLink(externalLinkId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExternalLinksConfigControllerApi
     */
    public findAllExternalLinks(options?: any) {
        return ExternalLinksConfigControllerApiFp(this.configuration).findAllExternalLinks(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} externalLinkId 
     * @param {ExternalLinkConfVO} externalLinkConfVO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExternalLinksConfigControllerApi
     */
    public updateExternalLink(externalLinkId: string, externalLinkConfVO: ExternalLinkConfVO, options?: any) {
        return ExternalLinksConfigControllerApiFp(this.configuration).updateExternalLink(externalLinkId, externalLinkConfVO, options).then((request) => request(this.axios, this.basePath));
    }
}
